import { useQuery } from '@tanstack/react-query';
import type { DashboardLimits } from '@ace-tracker/shared';
import { fetchDashboardLimits, UnauthorizedError } from './api';

/**
 * Data-retention limits from the API. Fixed for a deployment, so fetched once
 * per session. Undefined while loading or if the request fails — the range
 * picker then offers every preset, exactly as it did before limits existed.
 */
export function useDashboardLimits() {
  return useQuery<DashboardLimits>({
    queryKey: ['dashboard-limits'],
    queryFn: fetchDashboardLimits,
    staleTime: Infinity,
    retry: (failureCount, err) => !(err instanceof UnauthorizedError) && failureCount < 2,
  });
}
